import PropTypes from 'prop-types';
import { EmailIntegrationFeedDetailsPropType } from '@/modules/Comms';
import { TaskItemPropType } from '@/propTypes';

const FeedItemPropType = PropTypes.shape({
  action: PropTypes.string,
  campaignId: PropTypes.string,
  constituentId: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      txt: PropTypes.string,
    }),
  ),
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  created: PropTypes.string.isRequired,
  feedItemId: PropTypes.string.isRequired,
  feedDetails: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.instanceOf(EmailIntegrationFeedDetailsPropType),
  ]),
  isGlobal: PropTypes.bool,
  ownerOrgId: PropTypes.string,
  pinned: PropTypes.bool,
  updated: PropTypes.string.isRequired,
});

export const TaskFeedItemPropType = PropTypes.shape({
  ...FeedItemPropType,
  ...TaskItemPropType,
});

export default FeedItemPropType;
